export const firebaseConfig = {
    apiKey: "AIzaSyCK8D8g_rg22SBzARf_KUIpr6jCx5Itne0",
    authDomain: "skipwork-search-1572762714293.firebaseapp.com",
    databaseURL: "https://skipwork-search-1572762714293.firebaseio.com",
    projectId: "skipwork-search-1572762714293",
    storageBucket: "skipwork-search-1572762714293.appspot.com",
    messagingSenderId: "890293991650",
    appId: "1:890293991650:web:a9424df8bcadbfad34c6bb",
    measurementId: "G-DVHS36B00B"
};